"use client";

import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export default function ClubDetailCard(props: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={twMerge(
        `md:py-4 py-1 relative md:px-2 px-1 h-full w-full rounded text-center flex flex-col justify-center items-center ${props.className}`,
      )}
    >
      {props.children}
    </div>
  );
}
